import { defineStore } from "pinia";

import { useToast } from "@/composables/useToast.js";
import { usePrintersStore } from "@/store/printers/index.js";
import { IPagination } from "@/types/table.js";
import axios from "@/utils/axios.ts";

const { error } = useToast();

export const useDeliveryStore = defineStore("delivStore", {
  state: (): any => ({
    printersList: [],
    shipmentsList: [],
    isPrintersLoader: false,
    isShipmentLoader: false,
  }),
  actions: {
    async fetchPrinters(params?: IPagination) {
      this.isPrintersLoader = true;
      await axios.get("/delivery/printers", params as any)
        .then(({ data }) => {
          this.printersList = data;
        })
        .catch((errorResponse: any) => {
          error(errorResponse?.response?.data?.message || errorResponse?.message);
        })
        .finally(() => {
          this.isPrintersLoader = false;
        });
    },

    async fetchActualPrinters() {
      const printersStore = usePrintersStore();
      try {
        const { data } = await axios.get("/delivery/printers/actual");

        printersStore.setPrintersList(data);
      }
      catch (e) {
        console.log(e);
      }
    },

    async updateDefaultPrinter(printerId: number, labelId: number) {
      try {
        this.isPrintersLoader = true;
        await axios.patch(`/delivery/printers/${printerId}/default`, {
          labelId,
        });
        await this.fetchPrinters();
      }
      catch (error) {
        console.log(error);
      }
      finally {
        this.isPrintersLoader = false;
      }
    },
    async createDeliveryPrinter(printer: any, callback?: () => void) {
      this.isPrintersLoader = true;
      return axios.post("/delivery/printers", printer)
        .then(async () => {
          await this.fetchPrinters();
          callback && callback();
        })
        .finally(() => {
          this.isPrintersLoader = false;
        });
    },
  },
});
